import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, withModifiers as _withModifiers, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "base_screen_header"
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  key: 0,
  class: "base_main_header"
};
const _hoisted_4 = {
  key: 1,
  class: "base_main_margin_top"
};
import StatusBar from "@com/StatusBar.vue";
import DataCollectTable from "@com/table/DataCollectTable.vue";
import OrderShipments from "@com/order/OrderShipments.vue";
import CancelOrder from "@com/order/CancelOrder.vue";
import { OP_KEY, OPERATIONS, operationsHander } from "@com/table/tableOperations";
import { $msg, $box } from "@ui/msg";
import { ref, reactive } from "vue";
import { Search } from "@element-plus/icons-vue";
import useRoute from "@util/router";
import $ from "@util/base";
import configApi from "@api/config";
import api from "@api/order";
export default {
  __name: 'GoodsOrder',
  props: {
    type: {
      type: String
    },
    routeName: {
      type: String
    }
  },

  setup(__props) {
    const props = __props;
    const route = useRoute();
    route.watchRouter(props.routeName, () => {
      getData();
    }); // 1018001 未付款、1018002 待发货、1018003 已取消、1018004 待取货、1018005 待收货、1018006 已完成

    const statusList = reactive([{
      label: "全部",
      value: "all",
      total: 0
    }, {
      label: "待取货",
      value: "1018004",
      total: 0
    }, {
      label: "待发货",
      value: "1018002",
      total: 0
    }, {
      label: "待收货",
      value: "1018005",
      total: 0
    }, {
      label: "已完成",
      value: "1018006",
      total: 0
    }, {
      label: "订单取消",
      value: "1018003",
      total: 0
    }]);
    const baseOptions = ref([]);
    const base = ref(route.query().base || "");
    const main = ref(route.query().main || "");
    const orderCode = ref(route.query().orderCode || "");
    const name = ref(route.query().name || "");
    const date = ref(route.query().date || []);
    const total = ref(0);
    const data = ref([]);
    getConfig();

    function getConfig() {
      configApi.base(val => {
        baseOptions.value = val;
      });
    }

    function goodsOperations(data) {
      if (props.type == "order") {
        switch (data.orderStatus) {
          // 待发货
          case "1018002":
            return [OPERATIONS.check, OPERATIONS.shipments, OPERATIONS.cancelOrder];
          // 未付款

          case "1018001":
            return [OPERATIONS.check, OPERATIONS.cancelOrder];

          default:
            return [OPERATIONS.check];
        }
      } else {
        return [OPERATIONS.check];
      }
    }

    const config = {
      showIndex: true,
      operations: {
        label: "操作",
        width: 120,
        operations: goodsOperations
      },
      column: [// {
      //   label: "主订单编号",
      //   prop: "mainOrderCode",
      //   width: 120,
      // },
      {
        label: "订单编号",
        prop: "orderCode",
        width: 120
      }, {
        label: "综合活动码编号",
        prop: "exchangeItemCode",
        width: 120
      }, {
        label: "下单时间",
        prop: "createTime",
        width: 100
      }, {
        label: "商品名称",
        prop: "productName",
        width: 140
      }, {
        label: "商品数量",
        prop: "sellNum",
        width: 90
      }, {
        label: "订单状态",
        prop: "orderStatusStr",
        width: 100
      }, {
        label: "归属基地",
        prop: "shopName"
      }, {
        label: "分销员",
        prop: "agentMemberName",
        width: 90
      }, {
        label: "收货人",
        prop: "recipientName",
        width: 90
      }, {
        label: "联系方式",
        prop: "phoneNumber",
        width: 120
      }, {
        label: "发货人",
        prop: "updateExpressUser",
        width: 90
      }, {
        label: "发货时间",
        prop: "updateExpressTime",
        width: 100
      }, {
        label: "核销人",
        prop: "verifierName",
        width: 90
      }, {
        label: "核销时间",
        prop: "verificateTime",
        width: 100
      }]
    };
    const shipmentsRef = ref(null);
    const cancelOrderRef = ref(null);
    let selectOpData = null;
    const opHander = operationsHander();
    opHander.install(OP_KEY.check, data => {
      route.push({
        name: "goodsorderdetails",
        query: {
          code: data.orderCode
        }
      });
    });
    opHander.install(OP_KEY.shipments, data => {
      selectOpData = data; // deliveryType  1019001 快递配送、1019002 用户自提

      if (data.deliveryType == "1019001") {
        shipmentsRef.value.show();
      } else {
        shipments({});
      }
    });

    function shipments(data) {
      if (selectOpData != null) {
        api.shipment("goods", {
          orderCode: selectOpData.orderCode,
          expressDetail: data.express // expressName: data.company,
          // expressNo: data.number

        }, () => {
          $msg.succ("发货成功");
          getData();
        });
      } else {
        $msg.error("请重新选择记录操作");
      }
    }

    opHander.install(OP_KEY.cancelOrder, data => {
      selectOpData = data;
      cancelOrderRef.value.show();
    });

    function cancelOrder(data) {
      if (selectOpData != null) {
        api.cancel({
          type: "goods",
          code: selectOpData.orderCode,
          // amount: data.amount,
          remark: data.reason
        }, () => {
          $msg.succ("取消成功");
          getData();
        });
      } else {
        $msg.error("请重新选择记录操作");
      }
    }

    function pick() {
      $box.input("领取", "提货码", null, val => {
        api.pickup(val, () => {
          $box.open("提示", "提货成功");
          getData();
        }, msg => {
          $box.open("提货失败", msg);
        });
      });
    }

    function searchBase(val) {
      route.replaceQuery("base", val);
    }

    function searchMain(val) {
      route.replaceQuery("main", val);
    }

    function searchOrderCode(val) {
      route.replaceQuery("orderCode", val);
    }

    function searchName(val) {
      route.replaceQuery("name", val);
    }

    function searchDate(val) {
      route.replaceQuery("date", val);
    }

    getData();

    function getData() {
      getNum();
      getList();
    }

    function getNum() {
      let routeQuery = route.query();
      let params = {
        memberLoginName: routeQuery.login,
        shopCode: routeQuery.base,
        mainOrderCode: routeQuery.main,
        orderCode: routeQuery.orderCode,
        recipientName: routeQuery.name,
        status: routeQuery.status
      };

      if ($.isNotEmpty(routeQuery.date)) {
        params.startTime = routeQuery.date[0];
        params.endTime = routeQuery.date[1];
      }

      api.num(params, "goods", val => {
        statusData([val.total, val.pickup, val.send, val.receive, val.completed, val.cancel]);
      });
    }

    function statusData(val) {
      statusList.forEach((e, i) => {
        e.total = val[i];
      });
    }

    function getList() {
      let routeQuery = route.query();
      let params = {
        type: "goods",
        memberLoginName: routeQuery.login,
        shopCode: routeQuery.base,
        mainOrderCode: routeQuery.main,
        orderCode: routeQuery.orderCode,
        recipientName: routeQuery.name,
        status: routeQuery.status,
        date: routeQuery.date,
        page: routeQuery.p,
        size: routeQuery.s
      };
      api.orderList(params, val => {
        total.value = val.total; // val.list = [{orderStatus: "1018001", orderCode: "1018001"}, {orderStatus: "1018002"}, {orderStatus: "1018003"}, {orderStatus: "1018004"}, {orderStatus: "1018005"}, {orderStatus: "1018006"}]

        data.value = val.list.map(e => {
          // 1018001 未付款、1018002 待发货、1018003 已取消、1018004 待取货、1018005 待收货、1018006 已完成
          switch (e.orderStatus) {
            case "1018001":
              e.status = "未付款";
              break;

            case "1018002":
              e.status = "待发货";
              break;

            case "1018003":
              e.status = "已取消";
              break;

            case "1018004":
              e.status = "待取货";
              break;

            case "1018005":
              e.status = "待收货";
              break;

            case "1018006":
              e.status = "已完成";
              break;
          }

          return e;
        });
      });
    }

    function getExport() {
      let routeQuery = route.query();
      let params = {
        type: "goods",
        memberLoginName: routeQuery.login,
        shopCode: routeQuery.base,
        mainOrderCode: routeQuery.main,
        orderCode: routeQuery.orderCode,
        recipientName: routeQuery.name,
        status: routeQuery.status,
        date: routeQuery.date
      };
      api.export(params, val => {
        $.download(val.url, "商品订单导出");
      });
    }

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form = _resolveComponent("el-form");

      const _directive_auth = _resolveDirective("auth");

      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [props.type == 'order' ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        onClick: pick,
        type: "primary"
      }, {
        default: _withCtx(() => [_createTextVNode("自提取货")]),
        _: 1
      })), [[_directive_auth, _ctx.getCurCode('PICKUP')]]) : (_openBlock(), _createElementBlock("div", _hoisted_2)), _createVNode(_component_el_form, {
        inline: true,
        class: "base_search_form",
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_date_picker, {
            modelValue: date.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => date.value = $event),
            type: "daterange",
            "range-separator": "~",
            "start-placeholder": "开始时间",
            "end-placeholder": "结束时间",
            "value-format": "YYYY-MM-DD",
            onChange: searchDate
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: base.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => base.value = $event),
            onChange: searchBase,
            placeholder: "请选择基地",
            clearable: ""
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseOptions.value, (item, index) => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: index,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: orderCode.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => orderCode.value = $event),
            "onKeyup[native]": searchOrderCode,
            onChange: searchOrderCode,
            placeholder: "订单编号",
            "suffix-icon": _unref(Search),
            clearable: ""
          }, null, 8, ["modelValue", "suffix-icon"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: name.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => name.value = $event),
            "onKeyup[native]": searchName,
            onChange: searchName,
            placeholder: "收货人",
            "suffix-icon": _unref(Search),
            clearable: ""
          }, null, 8, ["modelValue", "suffix-icon"])]),
          _: 1
        })]),
        _: 1
      })]), _createVNode(StatusBar, {
        data: statusList,
        default: "all"
      }, null, 8, ["data"]), props.type == 'order' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_button, {
        type: "primary",
        text: "",
        onClick: getExport
      }, {
        default: _withCtx(() => [_createTextVNode("导出")]),
        _: 1
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_4)), _createVNode(DataCollectTable, {
        data: data.value,
        total: total.value,
        config: config,
        onOperationsHander: _unref(opHander).receive
      }, null, 8, ["data", "total", "onOperationsHander"]), _createVNode(OrderShipments, {
        ref_key: "shipmentsRef",
        ref: shipmentsRef,
        onShipments: shipments
      }, null, 512), _createVNode(CancelOrder, {
        ref_key: "cancelOrderRef",
        ref: cancelOrderRef,
        onCancelOrder: cancelOrder
      }, null, 512)]);
    };
  }

};